/*jQuery(document).ready(function($) {
  alert("Ok");
    let nextPage = $('.pagination a.pagination__item--prev').attr('href');
    $(window).scroll(function() {
        var already_entered = false;
        if (nextPage && $(window).scrollTop() >= $(document).height() - $(window).height() - 200 && already_entered == false) {
          console.log("Infinite Scroll...");
          already_entered = true;
            $.get(nextPage, function(data) {
                let products = $(data).find('.grid');
                $('.grid').append(products.html());
                nextPage = $(data).find('.pagination a.pagination__item--prev').attr('href');
            });
        }
    });
});*/

jQuery(document).ready(function($) {
    let nextPage = $('div.collection .pagination a.pagination__item--prev').attr('href');
    let loading = false; // Add a loading flag to prevent multiple calls

    let nextPage2 = $('div#shopify-section-template--14584317411410__main .pagination a.pagination__item--prev').attr('href');
    let loading2 = false; // Add a loading flag to prevent multiple calls
  

    $(window).scroll(function() {
        // Check if the next page exists and if we're not already loading
        if (nextPage && !loading && $(window).scrollTop() >= $(document).height() - $(window).height() - 200) {
            loading = true; // Set loading flag to true to prevent additional requests

            // Fetch next page content
            $.get(nextPage, function(data) {
                let products = $(data).find('div.collection .grid'); // Adjust this selector based on your theme's structure
                $('div.collection .grid').append(products.html()); // Append new products to the current grid

                // Update next page URL or set to null if no more pages
                nextPage = $(data).find('div.collection .pagination a.pagination__item--prev').attr('href');
                loading = false; // Reset loading flag for next scroll
            });
        }

        if (nextPage2 && !loading2 && $(window).scrollTop() >= $(document).height() - $(window).height() - 200) {
            loading2 = true; // Set loading flag to true to prevent additional requests

            // Fetch next page content
            $.get(nextPage2, function(data) {
                let products = $(data).find('div#shopify-section-template--14584317411410__main .grid'); // Adjust this selector based on your theme's structure
                $('div#shopify-section-template--14584317411410__main .grid').append(products.html()); // Append new products to the current grid

                // Update next page URL or set to null if no more pages
                nextPage2 = $(data).find('div#shopify-section-template--14584317411410__main .pagination a.pagination__item--prev').attr('href');
                loading2 = false; // Reset loading flag for next scroll
            });
        }

      
    });
});